import { HttpErrorHandlerService, MessageType } from './../../services/http-error-handling.service';
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Tariff } from '../../interfaces/tariff.interface';
import { EnvironmentService } from '../../services/environment.service';
import { FormDrawerService } from '../../services/form-drawer.service';
import { TariffService } from '../../services/tariff.service';
import { TariffViewerComponent } from './tariff-viewer/tariff-viewer.component';
import * as _ from 'lodash';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { BaseApp } from '../../Utility/subscriptions-destroyer/subscription-destroy-adapter';
import { Store } from '@ngxs/store';
import { BaseSharedState } from '../../store/base.state';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExternalNotesViewerComponent } from './external-notes-viewer';
import { CommonConstants } from '../../constants/common.constants';
import { takeUntil, filter } from 'rxjs/operators';

  @Component({
    selector: 'app-tariff-finder',
    templateUrl: './tariff-finder.component.html',
    styleUrls: ['./tariff-finder.component.less'],
    providers: [BaseApp]
  })
export class TariffFinderComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    public CommonConstants = CommonConstants;
    rdmList$: Observable<any>;

    @Input() searchByCountry = false ;
    @Input() singleSelect = false ;

    public tariffFinderUrl: '';
    public tariffUiTheme: '';
    public customInfoDestination="AE" ;
    public viewModel: {
      searchQuery?: string,
      tariffCode?: string,
      shortDescriptionInEnglish?: string,
      hsCodeList: Tariff[],
      url3CE: string,
      mode3CE?: boolean
    } = {
        searchQuery: '',
        tariffCode: '',
        hsCodeList: [],
        url3CE: '',
        mode3CE: false
      };
    public isAdvanceSearch = 'false';
    public isSpinningFind = false;
    public isViewEnabled = false;
    public canDisable = false;
    private ismoduleIsSmarttools:boolean;

    private isCustomInfo = false;

    public tId  = 0;
    public docType:any ;
    public department:any ;
    public ministry:any ;

    public pageSize=10;
    public totalElements = 0;
    public pageSizeOptions = [10, 20, 30, 40];
    private _pageIndex = 1;

    get pageIndex(): number {
      return this._pageIndex;
    }

    set pageIndex(value: number) {
      if (this._pageIndex !== value && this.isViewEnabled) {
        this._pageIndex = value;
        this.findHsCode(value);
      } else {
        this._pageIndex = value;
      }
    }

    @Input() public value:any;
    public isPreferentialSource = false;

    public selectedTariffs: Tariff[] = [];
    public isAllSelected = false;
    public indeterminate = false;

    constructor(
      private env: EnvironmentService,
      private drawerRef: NzDrawerRef,
      private formDrawerService: FormDrawerService,
      private clientService: TariffService,
      private subscribtions: BaseApp,
      private router: Router,
      private httpErrorHandlerService: HttpErrorHandlerService,
      private translate :TranslateService,
      private store: Store,
      private cdr: ChangeDetectorRef) {
        this.rdmList$ = this.store.select(BaseSharedState.getRdmData);

      this.tariffFinderUrl = this.env.getEnvironment().tariffFinderUrl;
      this.tariffUiTheme = this.env.getEnvironment().tariffUiTheme;

      window.addEventListener('message', (event) => {
        if (event.data && event.data['hsCode']) {
          this.viewModel.tariffCode = this.formatNumber(event.data['hsCode']);
          this.isAdvanceSearch = 'false';
          this.isViewEnabled = false;
          this.findHsCode(1);
          if(this.drawerRef.close) this.drawerRef.close({ tariffCode: this.viewModel.tariffCode });
        }
        if (event.data && event.data['abort'] == true) {
          this.isAdvanceSearch = 'false';
          this.isViewEnabled = false;
        }
      }, false);
    }

    ngOnInit():void{
      // Initialize RDM data subscription
      if (this.rdmList$) {
        this.rdmList$
          .pipe(
            takeUntil(this.destroy$),
            filter(res => res != null)
          )
          .subscribe(res => {
            // Handle RDM data if needed
          });
      }

      this.ismoduleIsSmarttools=this.router.url.toLowerCase().includes('smarttools');
      if(_.isEmpty(this.value)) return;

      // Check if opened from preferential tariff
      if (this.value?.source === 'preferential') {
        this.isPreferentialSource = true;
        if (this.value.hsCode) {
          this.viewModel.tariffCode = this.value.hsCode;
          this.findHsCode();
        }
        return;
      }

      // Check if singleSelect is passed via value
      if (this.value?.singleSelect !== undefined) {
        this.singleSelect = this.value.singleSelect;
      }

      if (typeof this.value == 'string') {
        this.viewModel.tariffCode = this.value.trim();
        this.canDisable = false;
        this.findHsCode();
      } else if (typeof this.value.hsCode != 'undefined') {
        this.isCustomInfo = true;
        this.viewModel.tariffCode = this.value.hsCode;
        this.customInfoDestination = this.value.destination;
        this.canDisable = false;
        if(!_.isEmpty(this.value.hsCode)) {
          this.findHsCode();
        }
      } else if (typeof this.value.code != 'undefined') {
        this.viewModel.tariffCode = this.value.code.trim();
        this.docType = this.value.docType;
        this.ministry = this.value.ministry;
        this.department = this.value.department;
        this.canDisable = true;
        this.findLpcoHsCode(this.docType,this.ministry,this.department, this.viewModel.tariffCode);
      }
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

findHsCode(page?:number): void {
      if(page)
        this.pageIndex=page
      this.isViewEnabled = true;
      this.isSpinningFind = true;
      this.viewModel.mode3CE = false;
      this.viewModel.hsCodeList = [];
      const offset = (this.pageIndex - 1) * this.pageSize;
      if(this.isPreferentialSource) {
        const hsCode = this.viewModel.tariffCode || null;
        const description = this.viewModel.shortDescriptionInEnglish || null;
        
        this.clientService.searchByHsCodeDescriptionAndHsType(hsCode, description, null, this.pageSize, this.pageIndex - 1, this.value?.isMapping)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res: any) => {
            this.isSpinningFind = false;
            if (res && res.tariffSearchDto) {
              this.viewModel.hsCodeList = res.tariffSearchDto['content'];
              this.totalElements = res.tariffSearchDto['totalElements'] || this.viewModel.hsCodeList.length;
            }
            this.updateCheckStatus();
            this.cdr.detectChanges();
          });
      } else if(this.ismoduleIsSmarttools){
        const customInfoHsCodes$ = this.clientService.getCustomInfoHsCodes(this.viewModel.tariffCode, this.viewModel.searchQuery,this.customInfoDestination, this.pageSize, this.pageIndex - 1);
        this.subscribtions.subs.add(
          customInfoHsCodes$.subscribe((res:any) => {
            this.isSpinningFind = false;
            if (res && res.tariffSearchDto) {
              this.viewModel.hsCodeList = res.tariffSearchDto['content'];
              this.totalElements = res.tariffSearchDto['totalElements'] || this.viewModel.hsCodeList.length;
            }else if(res.message== "ERROR"){
              this.httpErrorHandlerService.showTopFloatMessage(this.translate.instant(res?.errorMessage[0]?.detailErrorMessage), MessageType.ERROR);
            }
            this.updateCheckStatus();
            this.cdr.detectChanges();
          },(error:any)=> {
            this.httpErrorHandlerService.showContentMessage(error?.errorMessage, MessageType.ERROR);
          }
          ));
      }else{
        const hsCodesByDescription$ = this.clientService.getHsCodesByDescription(this.viewModel.tariffCode || this.viewModel.searchQuery,this.viewModel.shortDescriptionInEnglish, this.pageSize, this.pageIndex - 1);
        this.subscribtions.subs.add(
          hsCodesByDescription$.subscribe((res:any) => {
            this.isSpinningFind = false;
            if (res && res.tariffSearchDto) {
              this.viewModel.hsCodeList = res.tariffSearchDto['content'];
              this.totalElements = res.tariffSearchDto['totalElements'] || this.viewModel.hsCodeList.length;
            }
            this.updateCheckStatus();
            this.cdr.detectChanges();
          })
        );
      }
    }


    findLpcoHsCode(docType:any,ministry:any,department:any,tariffCode:any): void {
      this.isViewEnabled = true;
      if (this.isAdvanceSearch == 'false') {
        this.isSpinningFind = true;
        this.viewModel.mode3CE = false;
        this.viewModel.hsCodeList = [];
        if (!isNaN(Number(this.viewModel.searchQuery))) {
          this.clientService.loadLpcoHsCodes(docType,ministry,department,tariffCode).subscribe((res:any) => {
            this.isSpinningFind = false;
            if (res && res.tariffSearchDto) {
              this.viewModel.hsCodeList = res.tariffSearchDto['content'];
              this.totalElements = this.viewModel.hsCodeList.length;
            }
            this.updateCheckStatus();
            this.cdr.detectChanges();
          });
        } else {
          this.clientService.loadLpcoHsCodes(docType,ministry,department,tariffCode).subscribe((res:any) => {
            this.isSpinningFind = false;
            if (res && res.tariffSearchDto) {
              this.viewModel.hsCodeList = res.tariffSearchDto['content'];
              this.totalElements = this.viewModel.hsCodeList.length;
            }
            this.updateCheckStatus();
            this.cdr.detectChanges();
          });
        }
      } else {
        this.viewModel.tariffCode = '';
        this.viewModel.mode3CE = true;
        this.viewModel.url3CE = `${this.tariffFinderUrl}?theme=${this.tariffUiTheme}&product=${this.viewModel.searchQuery}&dest=${this.customInfoDestination}`;
      }
    }

    update3ceFrame(countryCode: any) {
      this.customInfoDestination=countryCode;
    }

    formatNumber(num: string): string {
      // return num.toString().replace(/\B(?=(\d{2})+(?!\d))/g, '.');
      return num.toString();
    }

    selectTariff(tariffId:number,tariffCode: string,vFrom: string,vTo: string,hsType:string,shortDesc?:string, uom?:string , isRestricted?:string): void {
      this.viewModel.tariffCode = this.formatNumber(tariffCode);
      if(this.drawerRef.close) this.drawerRef.close({tariffId:tariffId, tariffCode: this.viewModel.tariffCode,validFrom:vFrom,validTo:vTo,type:hsType,shortDesc:shortDesc, uom:uom , isRestricted:isRestricted});
    }

    tariffViewer(tariffId: number,tariffCode:string): void {
      if(this.ismoduleIsSmarttools){
        // fetching detais from unifiedsource
        this.clientService.getTariffDetails(tariffCode,this.customInfoDestination).subscribe(res => {
          if (res && res.content) {
            this.formDrawerService.openDrawerForm(TariffViewerComponent, this.panels.tariffViewer.name, res).subscribe((result:any) => {
              if (result && result.flag && result.flag == this.panels.tariffViewer.name) delete result['flag'];
            });
          }
        })
      }else{

        if(this.tId != tariffId){
          this.tId = tariffId;
          this.clientService.getTariffMaster(tariffId).subscribe((res) => {
            if (res && res.content) {
              this.formDrawerService.openDrawerForm(TariffViewerComponent, this.panels.tariffViewer.name, res).subscribe((result:any) => {
                if (result && result.flag && result.flag == this.panels.tariffViewer.name) delete result['flag'];
              });
            }
          });

        } else{
          return;
        }
      }
    }

    changePageSize(pageSize: number): void {
      this.pageSize = pageSize;
      this.pageIndex = 1;
      this.selectedTariffs = [];
      this.findHsCode(1);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    panels = {
      tariffViewer:{
        active: true,
        disabled: false,
        name: 'Tariff Viewer'
      }
    };

    public showExternalNotes(tariffId: number,hsCode:string):void{
      this.clientService.getFTADetailsbyTariffCode(
        hsCode,
        this.customInfoDestination
      ).subscribe((res:any)=>{
        if (res) {
          this.formDrawerService.openDrawerForm(ExternalNotesViewerComponent,this.translate.instant("app.common.tariff.viewer.view.notes") , res[0]).subscribe((result:any) => {
            if (result && result.flag && result.flag == this.translate.instant("app.common.tariff.viewer.view.notes")) delete result['flag'];
          });
        }
      });
    }

    // Checkbox handling methods
    onAllChecked(checked: boolean): void {
      this.viewModel.hsCodeList.forEach(item => {
        const index = this.selectedTariffs.findIndex(selected => selected.tariffId === item.tariffId);
        if (checked) {
          if (index === -1) {
            this.selectedTariffs.push(item);
          }
        } else {
          if (index !== -1) {
            this.selectedTariffs.splice(index, 1);
          }
        }
      });
      this.updateCheckStatus();
      this.cdr.detectChanges();
    }

    onItemChecked(item: Tariff, checked: boolean): void {
      if (this.singleSelect) {
        // Radio behavior: only one item selected at a time
        this.selectedTariffs = checked ? [item] : [];
      } else {
        const index = this.selectedTariffs.findIndex(selected => selected.tariffId === item.tariffId);
        if (checked) {
          if (index === -1) {
            this.selectedTariffs.push(item);
          }
        } else {
          if (index !== -1) {
            this.selectedTariffs.splice(index, 1);
          }
        }
      }
      this.updateCheckStatus();
      this.cdr.detectChanges();
    }

    updateCheckStatus(): void {
      const currentPageSelected = this.viewModel.hsCodeList.filter(item => this.isSelected(item)).length;
      this.isAllSelected = this.viewModel.hsCodeList.length > 0 && currentPageSelected === this.viewModel.hsCodeList.length;
      this.indeterminate = currentPageSelected > 0 && currentPageSelected < this.viewModel.hsCodeList.length;
    }

    isSelected(item: Tariff): boolean {
      return this.selectedTariffs.some(selected => selected.tariffId === item.tariffId);
    }

    selectMultipleTariffs(): void {
      if (this.selectedTariffs.length > 0) {
        if (this.drawerRef.close) {
          this.drawerRef.close({
            selectedTariffs: this.selectedTariffs.map(tariff => ({
              tariffId: tariff.tariffId,
              tariffCode: this.formatNumber(tariff.tariffCode),
              validFrom: tariff.validFrom,
              validTo: tariff.validTo,
              type: tariff.type,
              shortDesc: tariff.shortDescriptionInEnglish || tariff.shortDescriptionIn || tariff.descriptionInEnglish,
              description: tariff.descriptionInEnglish,
              uom: tariff.uom,
              isRestricted: tariff.isRestricted
            }))
          });
        }
      }
    }

    submit(): void {
      this.selectMultipleTariffs();
    }

    cancel(): void {
      if (this.drawerRef.close) {
        this.drawerRef.close();
      }
    }
}
 